/* @flow strict */

import _ from 'lodash';
import { emailRegexp, phoneRegexp } from '/client/src/constants';

const validateConfirmEmail = (email: string, phone: string, scrollCb: (HTMLElement) => void): boolean => {
  let isValid = true;

  let invalidEl = null;

  const emailEl = document.querySelector('#confirmationEmailSupportEmail');
  const emailVMsg = emailEl.parentNode.parentNode.querySelector('.vMsg');

  const phoneEl = document.querySelector('#confirmationEmailSupportPhone');
  const phoneVMsg = phoneEl.parentNode.parentNode.querySelector('.vMsg');

  if (!!_.size(email) && !emailRegexp.test(email)) {
    emailEl.classList.add('validationElement');
    emailVMsg.style.display = 'block';

    invalidEl = emailEl;
    isValid = false;
  } else {
    emailEl.classList.remove('validationElement');
    if (!!emailVMsg) emailVMsg.style.display = 'none';
  }

  if (!!_.size(phone) && !phoneRegexp.test(phone)) {
    phoneEl.classList.add('validationElement');
    phoneVMsg.style.display = 'block';

    invalidEl = phoneEl;
    isValid = false;
  } else {
    phoneEl.classList.remove('validationElement');
    if (!!phoneVMsg) phoneVMsg.style.display = 'none';
  }

  if (scrollCb) {
    scrollCb(invalidEl);
  }

  return isValid;
};

export default validateConfirmEmail;
